<template>
  <div class="dd-search">
      <div class="content">
        <div class="inp">
          <i class="iconfont" >&#xe65b;</i>
          <input  ref="input" :placeholder="word" v-model="keyWord" @keyup.enter="to_search" />
        </div>
        <div @click="closeSearchPop" class="cancel">取消</div>
      </div>
  </div>
</template>

<script>
export default {
  name:'ddsearch',
  props: {
    word: {
      type: String,
      default: '请输入商品/品牌/种类名称'
    },
    searchUrl: {
      type: String
    },
  },
  data() {
    return {
      word: "",
      keyWord:'',
      search_url:''
    };
  },
  mounted() {
    // this.keyWord =  this.word === '请输入商品/品牌/种类名称'?'':this.word
    this.search_url =  this.searchUrl

    this.$nextTick(() => {
      this.$refs.input.focus()
    })
  },
  methods: {
    // 关闭弹窗
    closeSearchPop(){
      this.$emit('closeSearchPopSend')
    },
    // 开始搜索 跳转搜索结果页
    to_search() {
      if(this.keyWord){
        let sortUrl = this.search_url.replace('xxx', this.keyWord).replace('xxx','0')
        this.$sys.dict.href(sortUrl);
      }else{
        if(this.word && this.word !== "请输入商品/品牌/种类名称"){
          let sortUrl = this.search_url.replace('xxx', this.word).replace('xxx','0')
          this.$sys.dict.href(sortUrl);
        }
      }
    },
  },
  destroyed() {
    clearTimeout(this.timer)
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .dd-search {
    height: 120px;
    .content {
      width: 100%;
      box-sizing: border-box;
      padding: 24px;
      height: 120px;
      display: flex;
      .inp{
        display: flex;
        flex: 6;
        height: 72px;
        background: #f5f5f5;
        border-radius: 40px;
        align-items: center;
        padding: 0 26px;
        i {
          font-size: 34px;
          color: #111111;
          margin-right: 14px;
        }
        input {
          height: 72px;
          width: 100%;
          background: none;
          &::-webkit-input-placeholder { /* WebKit browsers */
            color: #b6b6b6;
          }

          &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #b6b6b6;
          }

          &::-ms-input-placeholder { /* Internet Explorer 10+ */
            color: #b6b6b6;
          }
        }
       .word {
          flex: 1;
          font-size: 30px;
          color: #bebebe;
        }
      }
      .cancel{
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
      }
    }

  }
</style>
